import { SubtitleUrls } from "../models/captions/SubtitleUrls"
export default function mergeSubtitles(
  obj?: SubtitleUrls,
  arr?: SubtitleUrls[]
) {
  return (arr ? (obj ? [...arr, obj] : arr) : obj ? [obj] : [])
    .filter(x => x.srt_url != undefined)
    .sort(function (a, b) {
      return a.language > b.language ? 1 : -1
    })
}
